// Phase Response Card 1.0 Lite — background config defaults + helpers.
// Backend stores this dict at `section.data.background` for any RSVP section.
// Default `type: 'none'` means the renderer skips the layer entirely — zero
// visual / behavioral change for any existing event.

export const RSVP_BACKGROUND_TYPES = ['none', 'surface_texture', 'custom_image'];

export const RSVP_SURFACE_TEXTURES = {
  cotton_paper:   '/textures/cotton-paper.png',
  fine_art_paper: '/textures/fine-art-paper.png',
  soft_linen:     '/textures/soft-linen.png',
};

export const RSVP_SURFACE_LABELS = {
  cotton_paper:   'Cotton paper',
  fine_art_paper: 'Fine art paper',
  soft_linen:     'Soft linen',
};

export const RSVP_OVERLAY_OPTIONS = [
  { value: 'none',       label: 'No wash' },
  { value: 'ivory_wash', label: 'Ivory wash' },
  { value: 'white_wash', label: 'White wash' },
  { value: 'dark_wash',  label: 'Dark wash' },
];

export const DEFAULT_RSVP_BACKGROUND = {
  type: 'none',
  texture: undefined,
  imageUrl: undefined,
  target: 'card',
  fit: 'cover',
  position: 'center',
  opacity: 0.18,
  overlay: 'ivory_wash',
};

// Patch-merge helper used by the Studio control panel.
export function updateRSVPBackground(current, patch) {
  return { ...DEFAULT_RSVP_BACKGROUND, ...(current || {}), ...patch };
}

// Full reset — used by "Remove background" so stale imageUrl/texture don't
// linger in the saved data.
export function resetRSVPBackground() {
  return { ...DEFAULT_RSVP_BACKGROUND };
}
